import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Landing } from '@/domain/share/Landing';

export function EventEmail() {
  const [ query ] = useSearchParams();
  const qr = query.get('qr') ?? '';

  useEffect(() => {
    const encodedQr = encodeURIComponent(qr);
    const link = `theswing://scan/device?qr=${encodedQr}`;
    setTimeout(() => window.location.href = link, 400);
  }, []);

  return <Landing />;
}